import { makeContractEmailsRepository } from 'modules/customer/infra/repositories';

import { SendContractViaEmailUseCase } from './implementations/SendContractViaEmailUseCase';

let instance: SendContractViaEmailUseCase | null = null;

export default function makeSendContractViaEmailUseCase() {
  if (!instance) {
    const repository = makeContractEmailsRepository();

    instance = new SendContractViaEmailUseCase(repository);
  }

  return instance;
}
